import React from "react";
import { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import * as intchaine from "./interface-chaine";
import * as mem from "./recopieLotFournisseur";
// import {CancelToken } from "axios";
import axios from "axios";
import { QRCodeCanvas, QRCodeSVG } from "qrcode.react";
import { ImSpinner3 } from "react-icons/im";
import "./App.css";
import { DEBUG } from "./utilitaires";

export default function AffichageDernierLot() {
  //remplacer par get dernier Lot de fournisseur
  const [dernierLot, setDernierLot] = useState(0);
  const [infosLot, setInfosLot] = useState({});
  const [dataUrl, setDataUrl] = useState();
  const [tilt, setTilt] = useState(false);
  const [isloading, setIsLoading] = useState(true);
  const [nomFournisseur, setNomFournisseur] = useState("");
  //const [valeurRappel, setValeurRappel] = useState(false);


  useEffect(() => {
    var infosLottemp, dataUrltemp, dernierLottemp;

    async function bidon() {
      // dernierLottemp = (await intchaine.getLengthLots()) - 1;
      if (!intchaine.accountFournisseur) return;
      setIsLoading(true);
      dernierLottemp = await mem.getDernierLotFournisseur(
        intchaine.accountFournisseur
      );
      infosLottemp = await intchaine.getInfosLot(dernierLottemp);
      //console.log("infoslottemp[22] juste apres l appel  = ", infosLottemp[22]);
      setNomFournisseur(
        await intchaine.getNomFournisseurParNumF(infosLottemp[9])
      );
      var hashIm = infosLottemp[3];
      //setValeurRappel(await intchaine.getRappelLot(dernierLottemp));
      //console.log("lot et valeurRappel juste apres l appel  = ", dernierLottemp,  valeurRappel);
      if (DEBUG) console.log("typeLot: ", typeLot);
      if (DEBUG) console.log("hashIM = ", hashIm);
      // appel au serveur d'images
      if (hashIm) {
        if (DEBUG)
          console.log(
            "je vais appeler axios dans dernier lot pour accès serveur d'images"
          );
        let res = null;
        // const source = CancelToken.source();
        try {
          // setTimeout(() => {
          //   if (res == null) {
          //     source.cancel();
          //   }
          // }, 6000);
          res = await axios.get(
            "https://" + mem.addressIPRemoteimages + ":3008/download",
            // "https://" + mem.addressIPRemoteimages + ":3008/download",
            {
              responseType: "blob",
              params: { fichierImage: hashIm },
              timeout: 10000,
            }
          );
        } catch {
          alert("Problème avec le serveur d'mages");
        }

        if (DEBUG) console.log(res.data);
        dataUrltemp = URL.createObjectURL(res.data);
        if (DEBUG) console.log("j'ai appelé axios pour serveur d'images");
      }
      if (DEBUG) console.log("infosLottemp: ", infosLottemp);
      setInfosLot(infosLottemp);
      setDataUrl(dataUrltemp);
      setDernierLot(dernierLottemp);
      setIsLoading(false);
    } //bidon
    if (DEBUG) console.log("j'appelle bidon");
    bidon();
  }, [tilt]); //super astuce pour tout rafraichir

  var {
    0: typeLot,
    1: nomLot,
    2: libelle,
    3: hashIm,
    4: descrL,
    5: argum,
    6: lotsFi,
    7: pourcentL,
    8: lotsP,
    9: idF,
    10: dateL,
    11: noteL,
    12: classementL,
    13: fabL,
    14: catL,
    15: paysL,
    16: pourcentExt,
    17: carbone,
    18: carboneTot,
    19: carbonePert,
    20: carboneRaj,
    21: DLC,
    22: rappel
  } = infosLot;

  if(DEBUG) console.log("dans dernier lot, rappel = ", rappel);
  if(DEBUG) console.log("dans dernier lot, pourcentL = ", pourcentL);

  function handleRafraichir() {
    setTilt(!tilt); //super astuce pour tout rafraichir
    // setDernierLot((await intchaine.getLengthLots()) - 1);
  }

  if (!intchaine.accountFournisseur) {
    return <div>Aucun fournisseur choisi</div>;
  }
  return (
    <>
      {isloading && (
        <ImSpinner3
          color="grey"
          icon="spinner"
          className="spinner"
          style={{ height: 100, width: 100 }}
        />
      )}
      {dernierLot > 0 ? (
        <div
          style={{
            paddingLeft: "60px",
            marginLeft: "50px",
            marginRight: "50px",
            borderStyle: "solid",
            borderWidth: "2px",
          }}
        >
          <br />
          <br />
          <h3>Informations Dernier Lot</h3>
          <br />

          <p>
            <span style={{ color: "blue" }}>
              Numero de Lot dans la Blockchain:
            </span>{" "}
            {dernierLot}{" "}
            <Button
              style={{ fontSize: 12, padding: 3 }}
              variant="outline-primary"
              onClick={handleRafraichir}
            >
              Rafraîchir
            </Button>
          </p>

          {hashIm && (
            <>
              <p style={{ color: "blue" }}>Image:</p>
              <span>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{" "}
                <img src={dataUrl} alt="produit" width={100} height={100} />{" "}
              </span>
            </>
          )}
          <br />
          <br />
          {typeLot == "traceur" && (
            <>
              <p style={{ color: "blue" }}>QR Code:</p>
              <QRCodeCanvas
                value={dernierLot.toString()}
                size={256}
                bgColor={"#ffffff"}
                //fgColor={"#000000"}
                fgColor={"red"}
                level={"H"}
                includeMargin={true}
                imageSettings={{src:"text-to-image.png", height: 20, width: 20  ,excavate: true}}
              />
            </>
          )}

          <p>
            <span style={{ color: "blue" }}>Type du Lot: </span>
            {typeLot}
          </p>
          <p>
            <span style={{ color: "blue" }}>Numéro de Lot Fournisseur: </span>
            {nomLot}
          </p>
          <p>
            <span style={{ color: "blue" }}>Dénomination: </span>
            {libelle}
          </p>

          {typeLot == "traceur" && (
            <p>
              <span style={{ color: "blue" }}>Fichier image: </span>
              {hashIm}
            </p>
          )}

          <p style={{ whiteSpace: "pre-wrap" }}>
            <span style={{ color: "blue" }}>Description: </span>
            {descrL}
          </p>

          {typeLot == "traceur" && (
            <>
              <p style={{ whiteSpace: "pre-wrap" }}>
                <span style={{ color: "blue" }}>
                  Votre Argumentaire pour ce lot:{" "}
                </span>
                <br />
                {argum}
              </p>
              <p style={{ whiteSpace: "pre-wrap" }}>
                <span style={{ color: "blue" }}>
                  Pourcentage d'ingrédients extérieurs:{" "}
                </span>
                {pourcentExt}
              </p>
              <p>
                <span style={{ color: "blue" }}>Lots Fils: </span>
                {lotsFi && lotsFi.join(", ")}
              </p>
              <p>
                <span style={{ color: "blue" }}>
                  Pourcentages dans le contenu des Lots Fils:{" "}
                </span>
                {pourcentL && pourcentL.join()}
              </p>
            </>
          )}

          <p>
            <span style={{ color: "blue" }}>Lots Pères: </span>
            {lotsP && lotsP.join()}
          </p>

          {typeLot == "traceur" && (
            <>
              <p>
                <span style={{ color: "blue" }}>Fournisseur: </span>
                {nomFournisseur}
              </p>
              <p>
                <span style={{ color: "blue" }}>Note: </span>
                {noteL}
              </p>
              <p>
                <span style={{ color: "blue" }}>Classement: </span>
                {classementL}
              </p>
            </>
          )}

          {typeLot == "fournisseur" && (
            <>
              <p>
                <span style={{ color: "blue" }}>Fabricant: </span>
                {fabL}
              </p>
              <p>
                <span style={{ color: "blue" }}>Pays du Fabricant: </span>
                {paysL}
              </p>
            </>
          )}

          <p>
            <span style={{ color: "blue" }}>
              Empreinte carbone des Ingrédients internes:{" "}
            </span>
            {carbone}
          </p>
          <p>
            <span style={{ color: "blue" }}>Empreinte carbone Totale: </span>
            {carboneTot}
          </p>
          <p>
            <span style={{ color: "blue" }}>
              Empreinte carbone Totale pertinente:{" "}
            </span>
            {carbonePert.toString()}
          </p>
          <p>
            <span style={{ color: "blue" }}>
              Empreintes carbone rajoutées pour les lots fils:{" "}
            </span>
            {carboneRaj && carboneRaj.join(", ")}
          </p>
          <p>
            <span style={{ color: "blue" }}>Date Limite de consommation: </span>
            {DLC}
          </p>
          <p>
            <span style={{ color: "blue" }}>Rappel: </span>
            {rappel.toString()}
          </p>          

          <p>
            <span style={{ color: "blue" }}>
              Date de création du Lot sur la Blockchain:{" "}
            </span>
            {dateL}
          </p>

          <p>
            ---------------------------------------------------------------------------------
          </p>
          <br />
        </div>
      ) : (
        <p>Aucun Lot</p>
      )}{" "}
      {/* fin operateur ternaire, si dernierlot ==0, on affiche Aucun Lot*/}
    </>
  );
}
